/* eslint-disable @typescript-eslint/no-explicit-any */
export const validationsSelector = (state: $TSMigrationFixMe) =>
  state.validations

export const certificadoValidationSelector = (state: $TSMigrationFixMe) =>
  state.validations.certificateValidation

export const certificadoEmpresaValidacion = (state: $TSMigrationFixMe) =>
  state.validations.showModalEmpresaCertificado

export const certificadoInvalidCertficiado = (state: $TSMigrationFixMe) =>
  state.validations.showModalInvalidCertificado
